import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  tableContainer: {
    flex: 1,
    margin: '24px 2% 0 34px',
  },
  mainTable: {
    marginTop: '16px',
    width: 'auto',
    height: '650px',
  },
  categoryChip: {
    marginRight: '4px',
  },
}))
